import React, { useState,useEffect  } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";

function Ratingfactors() {
    const ID = Cookies.get("log_id");
    const [ratingFactors, setRatingFactors] = useState([]);
    const [formData, setFormData] = useState({
        ratingFactor: "",
        description: "",  
    });

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });
    const fetchRatingFactors = async () => {
        try {
            const response = await axios.get(`${url.path}/ratingfactors/${ID}/`);
            setRatingFactors(response.data); // Update state with fetched data
        } catch (error) {
            console.error("Error fetching rating factors", error);
            Toast.fire({
                icon: "error",
                title: "Error fetching rating factors. Please try again.",
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!ID) {
            Toast.fire({
                icon: "error",
                title: "User not logged in. Please log in first.",
            });
            return;
        }

        try {
            const payload = {
                ...formData,
                id: ID, // Add the log_id
            };
            const response = await axios.post(`${url.path}/ratingfactor_add/`, payload);
            setRatingFactors([...ratingFactors, response.data]); // Update state
            setFormData({
                ratingFactor: "",
                description: "",
            });
            Toast.fire({
                icon: "success",
                title: "Rating Factor added successfully!",
            });
        } catch (error) {
            console.error("Error adding rating factor", error);
            Toast.fire({
                icon: "error",
                title: "Error adding rating factor. Please try again.",
            });
        }
        fetchRatingFactors();
    };
    useEffect(() => {
      

        fetchRatingFactors();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    return (
        <>
            <CompanyNavbar />
            <div className="page-wrapper">
                <div className="form-container">
                    <h1 className="text-2xl font-bold mb-4">Rating Factor</h1>
                    <form onSubmit={handleSubmit} className="mb-6 space-y-4">
                        <div>
                            <label className="block font-medium">Rating Factor</label>
                            <input
                                type="text"
                                name="ratingFactor"
                                value={formData.ratingFactor}
                                onChange={handleChange}
                                className="w-full border rounded p-2"
                                required
                            />
                        </div>
                        <div>
                            <label className="block font-medium">Description</label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="w-full border rounded p-2"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                            Add Rating Factor
                        </button>
                    </form>
                </div>

                <div className="form-container">         {/* Existing Rating Factors Section */}
    <h2 className="font-bold text-lg mb-4">Existing Rating Factors:</h2>
    <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
            <tr className="bg-gray-200">
                <th className="border border-gray-300 px-4 py-2 text-left">#</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Rating Factor</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Description</th>
            </tr>
        </thead>
        <tbody>
            {ratingFactors.length > 0 ? (
                ratingFactors.map((factor, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                        <td className="border border-gray-300 px-4 py-2">{index + 1}</td>
                        <td className="border border-gray-300 px-4 py-2">{factor.rating_factor}</td>
                        <td className="border border-gray-300 px-4 py-2">{factor.description}</td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td
                        colSpan="3"
                        className="border border-gray-300 px-4 py-2 text-center text-gray-500"
                    >
                        No rating factors available.
                    </td>
                </tr>
            )}
        </tbody>
    </table>
</div>
</div>


        </>
    );
}

export default Ratingfactors;
